(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('UploadedModelsMenuItemController', UploadedModelsMenuItemController);

    UploadedModelsMenuItemController.$inject = ['$scope', 'modelTabWorkflow', 'eventService', 'upload3DModelTrackEventsService', 'uploadModelConsts'];

    function UploadedModelsMenuItemController($scope, modelTabWorkflow, eventService, upload3DModelTrackEventsService, consts) {
        var vm = this;
        var prevUploadedModelsViewModel = $scope.$parent.vm;

        vm.select = selectModel;
        eventService.subscribe($scope, consts.eventNames.menuItemOpened, menuItemOpened);

        // ---------------------------------------------------------------------------------------------

        function menuItemOpened(menuItemName) {
            if (menuItemName === 'PreviouslyUploadedModel') {
                prevUploadedModelsViewModel.reload();
                upload3DModelTrackEventsService.trackRecentModelMenuOpened();
            }
        }

        function selectModel(modelId) {
            closeMenu();
            modelTabWorkflow.abortAndSelectModel(modelId);
            upload3DModelTrackEventsService.trackRecentModelSelected();
        }

        // ---------------------------------------------------------------------------------------------

        function closeMenu() {
            $scope.$parent.menuViewModel.closeMenu();
        }
    }
})();
